"use client";
import { useTheme } from "@mui/material/styles";
import { Breakpoint, useMediaQuery } from "@mui/material";

export const useResponsive = (start: Breakpoint, end: Breakpoint = "xl") => {
  const theme = useTheme();

  const up = useMediaQuery(theme.breakpoints.up(start), { noSsr: true });
  const down = useMediaQuery(theme.breakpoints.down(start));
  const between = useMediaQuery(theme.breakpoints.between(start, end || start));
  const only = useMediaQuery(theme.breakpoints.only(start));

  return {
    up,
    down,
    between,
    only,
  };
};
